import API from './API';
import store from './store';

const NotificationsService = (() => {
	var xhr = undefined;
	var timeout_id = undefined;

	const stop = () => {
		if (xhr !== undefined) {
			xhr.abort();
			xhr = undefined;
		}
		if (timeout_id !== undefined) {
			clearTimeout(timeout_id);
			timeout_id = undefined;
		}
	};

	const ping = () => {
		stop();
		var last_max_id;
		var last_seen_until_id;

		var pong; pong = () => {
			var args = {};
			if (last_max_id) args = {...args, last_max_id};
			if (last_seen_until_id) args = {...args, last_seen_until_id};
			if (window.GLOBAL_LANG) args.lang = window.GLOBAL_LANG;
			xhr = API.get("/a/notification_info", args, (response, status) => {
				xhr = undefined;
				var value = 0;
				if (status >= 200 && status < 300) {
					value = Math.max(0, response.MaxId - response.SeenUntilId);
					last_max_id = response.MaxId;
					last_seen_until_id = response.SeenUntilId;
				}
				store.dispatch_value("unseen_notifications", value);
				timeout_id = setTimeout(pong, 5000);
			});
		};
		pong();
	}

	var has_me = false;
	const chk_state = () => {
		const state = store.getState();
		if (!!state.me && !has_me) {
			ping();
			has_me = true;
		} else if (!state.me && has_me) {
			stop();
			has_me = false;
		}
	};

	chk_state();
	store.subscribe(chk_state);

	return {
		ping,
	};
})();

export default NotificationsService



// WEBPACK FOOTER //
// ./src/NotificationsService.js